import React, { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { HiX } from "react-icons/hi";

const UserActionModal = ({
  open,
  onClose,
  title,
  description,
  confirmLabel,
  destructive = false,
  submitting = false,
  onSubmit,
}) => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  const handleClose = () => {
    if (submitting) {
      return;
    }

    setReason("");
    setError("");
    onClose();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (reason.trim().length < 10) {
      setError("Reason must be at least 10 characters.");
      return;
    }

    setError("");
    await onSubmit(reason.trim());
    setReason("");
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-[10002]" onClose={handleClose}>
        <Transition.Child as={Fragment} enter="ease-out duration-200" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-150" leaveFrom="opacity-100" leaveTo="opacity-0">
          <div className="fixed inset-0 bg-gray-500/50" />
        </Transition.Child>

        <div className="fixed inset-0 z-[10002] overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <Transition.Child as={Fragment} enter="ease-out duration-200" enterFrom="opacity-0 translate-y-4" enterTo="opacity-100 translate-y-0" leave="ease-in duration-150" leaveFrom="opacity-100 translate-y-0" leaveTo="opacity-0 translate-y-4">
              <Dialog.Panel className="w-full max-w-lg rounded-xl bg-white p-6 shadow-xl">
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <Dialog.Title className="text-lg font-semibold text-gray-900">{title}</Dialog.Title>
                    {description ? (
                      <Dialog.Description className="mt-1 text-sm text-gray-500">{description}</Dialog.Description>
                    ) : null}
                  </div>
                  <button type="button" onClick={handleClose} className="rounded-lg p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-600">
                    <HiX className="h-5 w-5" aria-hidden="true" />
                  </button>
                </div>

                <form onSubmit={handleSubmit} className="mt-5 space-y-4">
                  <div>
                    <label htmlFor="user-action-reason" className="block text-sm font-medium text-gray-700">
                      Reason
                    </label>
                    <textarea
                      id="user-action-reason"
                      rows={4}
                      value={reason}
                      onChange={(event) => setReason(event.target.value)}
                      className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-900 focus-visible:border-indigo-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
                    />
                    {error ? <p className="mt-1 text-sm text-red-600">{error}</p> : null}
                  </div>

                  <div className="flex justify-end gap-2">
                    <button type="button" onClick={handleClose} disabled={submitting} className="rounded-lg px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100">
                      Cancel
                    </button>
                    <button
                      type="submit"
                      disabled={submitting}
                      className={`rounded-lg px-4 py-2 text-sm font-medium text-white disabled:opacity-60 ${
                        destructive ? "bg-red-600 hover:bg-red-700" : "bg-indigo-600 hover:bg-indigo-700"
                      }`}
                    >
                      {submitting ? "Working…" : confirmLabel}
                    </button>
                  </div>
                </form>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default UserActionModal;
